import React from 'react'
import PropTypes from 'prop-types'
import {Text, useStyleConfig, HStack} from '@chakra-ui/react'
import {BRAND_CODE_MARKETING_CLOUD} from '../../../brand'

const InformativeLabel = ({label, variant = '', width = 'auto', height = 'auto', icon = null}) => {
    const styles = useStyleConfig('InformativeLabel', {variant})
    const shouldRenderIcon = variant === 'bundle' && icon
    if (shouldRenderIcon) {
        return (
            <HStack {...styles} width={width} height={height}>
                {icon}
                <Text className={`${BRAND_CODE_MARKETING_CLOUD}-pdp__main-info__promo`}>
                    {label}
                </Text>
            </HStack>
        )
    }
    return (
        // className added for MC/MCP
        <Text
            className={`${BRAND_CODE_MARKETING_CLOUD}-pdp__main-info__promo`}
            {...styles}
            width={width}
            height={height}
        >
            {label}
        </Text>
    )
}

InformativeLabel.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    variant: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    icon: PropTypes.node,
}

export default InformativeLabel
